module.exports = __webpack_public_path__ + "media/images/person/review_devin-5c9d4a94b4e4886db19acd333a5b3e70.jpg";